import CTAccordion from './ctAccordion/ctAccordion.component';
export { CTAccordion };
